// extracted by mini-css-extract-plugin
export default {"authFooter":"styles_authFooter__Q+N-B"};